module.exports = __webpack_public_path__ + "img/left2.0ec94906.png";